import {
    useEffect,
    useRef,
    ComponentPropsWithoutRef,
    forwardRef,
    Ref,
    useImperativeHandle,
} from "react";

const PackCanvas = forwardRef((props: Props, ref: Ref<CanvasRef>) => {
    const canvasRef = useRef<HTMLCanvasElement | null>(null);
    const height = 1920;
    const width = 1080;

    useImperativeHandle(ref, () => ({
        toDataURL() {
            if (canvasRef.current) {
                return canvasRef.current.toDataURL("image/png");
            } else return undefined;
        },
    }));

    useEffect(() => {
        const canvas = canvasRef.current;
        if (canvas) {
            const ctx = canvas.getContext("2d");
            if (ctx) {
                //Generate the image
                var img = new Image();
                img.crossOrigin = "anonymous";
                img.src = props.image;
                img.onload = (e: any) => {
                    ctx.drawImage(img, 0, 0, width, height);
                };
            }
        }
    }, [props.image]);

    return <canvas ref={canvasRef} width={width} height={height} {...props} />;
});
export default PackCanvas;
export interface Props extends ComponentPropsWithoutRef<"canvas"> {
    image: string;
    textColor: string;
    design: string;
}
export interface CanvasRef {
    toDataURL: () => string | undefined;
}
